/**
 * Canonical catalog of vehicle brands & models sold in Mexico, plus the
 * standardized set of colors and the allowed model-year range. Used by
 * the "Agregar Nuevo Vehículo" host flow so listings share a consistent,
 * typo-free data shape across the marketplace.
 *
 * Every brand also exposes an "Otro" model option so hosts can submit a
 * model that isn't listed yet — those listings get flagged for admin review.
 */

export const OTHER_MODEL_OPTION = "Otro";

export const VEHICLE_BRANDS_MEXICO = {
  "Acura": ["ILX", "TLX", "Integra", "RDX", "MDX"],
  "Alfa Romeo": ["Giulia", "Stelvio", "Tonale"],
  "Audi": ["A1", "A3", "A4", "A5", "A6", "A7", "A8", "Q2", "Q3", "Q5", "Q7", "Q8", "e-tron", "Q4 e-tron", "RS3", "RS5", "RS6", "RS Q8"],
  "BAIC": ["D20", "X25", "X35", "X55", "BJ40", "BJ60"],
  "BMW": ["Serie 1", "Serie 2", "Serie 3", "Serie 4", "Serie 5", "Serie 7", "X1", "X2", "X3", "X4", "X5", "X6", "X7", "i3", "i4", "iX", "iX3", "M2", "M3", "M4", "M5"],
  "BYD": ["Dolphin", "Dolphin Mini", "Seal", "Han", "Tang", "Song Plus", "Yuan Plus", "King", "Shark"],
  "Cadillac": ["ATS", "CTS", "XT4", "XT5", "XT6", "Escalade", "Lyriq"],
  "Changan": ["Alsvin", "CS35 Plus", "CS55 Plus", "CS75 Plus", "Uni-T", "Uni-K", "Hunter"],
  "Chery": ["Tiggo 2 Pro", "Tiggo 4 Pro", "Tiggo 7 Pro", "Tiggo 8 Pro", "Arrizo 5", "Arrizo 8"],
  "Chevrolet": ["Aveo", "Spark", "Beat", "Sonic", "Onix", "Cruze", "Malibu", "Cavalier", "Tracker", "Trax", "Captiva", "Equinox", "Blazer", "Traverse", "Tahoe", "Suburban", "Colorado", "Silverado", "Cheyenne", "Bolt EV", "Bolt EUV", "Camaro", "Corvette"],
  "Chrysler": ["200", "300", "Pacifica", "Town & Country"],
  "Cupra": ["Formentor", "Ateca", "León", "Born", "Terramar", "Tavascan"],
  "Dodge": ["Attitude", "Neon", "Journey", "Durango", "Charger", "Challenger"],
  "Fiat": ["Mobi", "Uno", "Argo", "Pulse", "Fastback", "Ducato", "500", "500e"],
  "Ford": ["Figo", "Fiesta", "Focus", "Fusion", "Mustang", "EcoSport", "Territory", "Escape", "Edge", "Explorer", "Expedition", "Bronco", "Bronco Sport", "Maverick", "Ranger", "Lobo", "F-150", "Super Duty", "Mustang Mach-E", "Transit"],
  "GAC": ["GS3", "GS4", "GS8", "Emkoo", "Empow", "Aion Y", "Aion V"],
  "Geely": ["Coolray", "Geometry C", "GX3 Pro", "Okavango", "Starray", "Emgrand"],
  "GMC": ["Terrain", "Acadia", "Yukon", "Sierra", "Hummer EV"],
  "Great Wall / GWM": ["Haval H6", "Haval Jolion", "Haval H7", "Tank 300", "Tank 500", "Ora 03", "Poer"],
  "Honda": ["City", "Civic", "Accord", "BR-V", "HR-V", "CR-V", "Pilot", "Odyssey", "Ridgeline", "Fit"],
  "Hyundai": ["Grand i10", "Accent", "Elantra", "Sonata", "Creta", "Venue", "Tucson", "Santa Fe", "Palisade", "Staria", "Ioniq", "Kona", "HB20"],
  "Infiniti": ["Q50", "Q60", "QX50", "QX55", "QX60", "QX80"],
  "Isuzu": ["D-Max", "Elf", "Forward"],
  "JAC": ["J2", "J3", "J4", "J7", "Sei 2", "Sei 3", "Sei 4", "Sei 7", "Frison T6", "Frison T8", "E10X", "E Sei 4"],
  "Jaguar": ["XE", "XF", "F-Type", "E-Pace", "F-Pace", "I-Pace"],
  "Jeep": ["Renegade", "Compass", "Cherokee", "Grand Cherokee", "Wrangler", "Gladiator", "Commander", "Wagoneer", "Grand Wagoneer"],
  "Jetour": ["X70", "X70 Plus", "X90 Plus", "Dashing", "T2"],
  "Kia": ["Rio", "Forte", "K3", "K4", "Optima", "K5", "Soul", "Seltos", "Sportage", "Sorento", "Telluride", "Carnival", "Niro", "EV6", "EV9"],
  "Land Rover": ["Range Rover Evoque", "Range Rover Velar", "Range Rover Sport", "Range Rover", "Discovery Sport", "Discovery", "Defender"],
  "Lexus": ["IS", "ES", "LS", "UX", "NX", "RX", "GX", "LX", "RZ"],
  "Lincoln": ["MKZ", "Corsair", "Nautilus", "Aviator", "Navigator"],
  "Mazda": ["Mazda 2", "Mazda 3", "Mazda 6", "CX-3", "CX-30", "CX-5", "CX-50", "CX-7", "CX-9", "CX-90", "MX-5"],
  "Mercedes-Benz": ["Clase A", "Clase B", "Clase C", "Clase E", "Clase S", "CLA", "CLS", "GLA", "GLB", "GLC", "GLE", "GLS", "G-Class", "EQA", "EQB", "EQC", "EQE", "EQS", "AMG GT", "Vito", "Sprinter"],
  "MG": ["MG 3", "MG 5", "MG 6", "MG GT", "MG ZS", "MG HS", "MG RX5", "MG One", "MG Marvel R", "MG4", "MG Cyberster"],
  "Mini": ["Cooper", "Cooper S", "Clubman", "Countryman", "Convertible", "Aceman"],
  "Mitsubishi": ["Mirage", "Lancer", "Outlander", "Outlander Sport", "Eclipse Cross", "Xpander", "Montero Sport", "L200"],
  "Nissan": ["March", "Versa", "Sentra", "Altima", "Maxima", "Kicks", "X-Trail", "Pathfinder", "Armada", "Frontier", "NP300", "Urvan", "Leaf", "Z", "GT-R"],
  "Omoda": ["Omoda C5", "Omoda E5"],
  "Peugeot": ["208", "301", "2008", "3008", "5008", "Rifter", "Partner", "Expert", "Manager"],
  "Porsche": ["718 Boxster", "718 Cayman", "911", "Panamera", "Macan", "Cayenne", "Taycan"],
  "RAM": ["700", "1200", "1500", "2500", "3500", "Promaster", "Promaster Rapid"],
  "Renault": ["Kwid", "Logan", "Sandero", "Stepway", "Duster", "Captur", "Koleos", "Oroch", "Kangoo", "Kardian"],
  "Seat": ["Ibiza", "León", "Arona", "Ateca", "Tarraco"],
  "Smart": ["Fortwo", "Forfour", "#1", "#3"],
  "Subaru": ["Impreza", "WRX", "Legacy", "XV", "Crosstrek", "Forester", "Outback", "BRZ", "Ascent"],
  "Suzuki": ["Ignis", "Swift", "Ciaz", "Baleno", "Ertiga", "S-Cross", "Vitara", "Jimny"],
  "Tesla": ["Model 3", "Model Y", "Model S", "Model X", "Cybertruck"],
  "Toyota": ["Yaris", "Corolla", "Camry", "Prius", "Raize", "Corolla Cross", "C-HR", "RAV4", "Highlander", "4Runner", "Sequoia", "Sienna", "Avanza", "Hilux", "Tacoma", "Tundra", "Land Cruiser", "Supra"],
  "Volkswagen": ["Gol", "Polo", "Vento", "Virtus", "Jetta", "Passat", "Beetle", "Golf", "GTI", "T-Cross", "Taos", "Tiguan", "Teramont", "Touareg", "Amarok", "Saveiro", "Crafter", "ID.4"],
  "Volvo": ["S60", "S90", "V60", "XC40", "XC60", "XC90", "EX30", "EX40", "EX90"],
  "Zeekr": ["X", "001", "009"],
  "Otro": [],
};

export const VEHICLE_COLORS_ES = [
  "Blanco",
  "Negro",
  "Gris",
  "Plata",
  "Rojo",
  "Azul",
  "Verde",
  "Amarillo",
  "Naranja",
  "Café",
  "Beige",
  "Dorado",
  "Morado",
  "Vino",
  "Otro",
];

export function getBrandNames() {
  const names = Object.keys(VEHICLE_BRANDS_MEXICO).filter((k) => k !== "Otro");
  names.sort((a, b) => a.localeCompare(b, "es"));
  names.push("Otro"); // Always last so it's easy to find
  return names;
}

export function getModelsForBrand(brandName) {
  if (!brandName) return [];
  const list = VEHICLE_BRANDS_MEXICO[brandName] || [];
  const sorted = [...list].sort((a, b) => a.localeCompare(b, "es"));
  // Every brand offers "Otro" so hosts can submit an unlisted model —
  // those listings are flagged for admin review before publishing.
  sorted.push(OTHER_MODEL_OPTION);
  return sorted;
}

// Model-year window: 2016 → current year (min 2026 so the full requested
// range 2016–2026 is always available).
export function getAllowedYears() {
  const current = Math.max(new Date().getFullYear(), 2026);
  const years = [];
  for (let y = current; y >= 2016; y--) years.push(y);
  return years;
}
